import type { DefaultSeoProps } from "next-seo";

const defaultConfig: DefaultSeoProps = {
  defaultTitle: "Fiberplane",
  description: "The collaborative platform for SRE and DevOps",
  titleTemplate: "%s | Fiberplane",
  additionalLinkTags: [
    {
      rel: "icon",
      href: "/favicon.ico",
    },
    {
      rel: "apple-touch-icon",
      href: "/favicon.png",
      sizes: "120x120",
    },
  ],
  openGraph: {
    url: "https://fiberplane.dev/",
    title: "Fiberplane",
    site_name: "Fiberplane",
    images: [
      {
        url: "https://fiberplane.dev/favicon.png",
        width: 128,
        height: 128,
        alt: "logo",
      },
    ],
  },
  twitter: {
    handle: "@fiberplane",
    site: "@fiberplane",
    cardType: "summary",
  },
};

export default defaultConfig;
